<template>

  <ContentsProductHighPerformancePageTitle title="PPS (Polyphenylene sulfide)" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/pps01.jpg"
            credit="Photo credit : https://www.toray.co.th"
            :contents="[
              `PPS is low-cost high performing material. Its heat aging is up to 240c, extreme chemical resistance to
              acid, alkaline, oil, alcohol, good dimensional and hydrolysis stability, inherent flame retardant, strong
              and rigid, high strength and modulus.`,
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/pps02.jpg"
            credit="Photo credit : https://www.toray.co.th"
            :contents="[
              `Fluid engineering applications where excellent corrosion and chemical resistance are needed like water pump. Food contact and drinking water approvals, NSF, KTW, WRAS, ACS, FDA is available, automotive headlamp reflector, industrial applications, hot water, high pressure, solenoid valves, chopsticks, semicon handling, motor insulator, kitchen appliances`,
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'Toray',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-torry.jpg',
              },
            },
            {
              name: 'Polyplastics',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-poly.jpg',
              },
            },
            {
              name: 'DSM',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-dsm.jpg',
              },
            },
            {
              name: 'Celanese',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-calane.jpg',
              },
            },
            {
              name: 'DIC',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-dic.jpg',
              },
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'pps - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>
.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>